import EventsLog from 'components/tables/EventsLogTable';

export default EventsLog;
